// Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

const companyLinks = [
  { name: "About", to: "/about" },
  { name: "Pricing", to: "/pricing" },
  { name: "Contact Us", to: "/contact" },
  { name: "Affiliate Program", to: "/affiliate/signup" },
];
const resourceLinks = [
  { name: "Blogs", to: "/blogs" },
  { name: "Privacy Policy", to: "/privacy" },
  { name: "Terms & Conditions", to: "/terms" },
];
const socials = [];

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 py-10 px-4 md:px-16 mt-10">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">
        <div className="flex flex-col items-center md:items-start gap-3">
          <div className="flex items-center gap-2 mb-2 font-bold text-xl text-primary">
            <svg width="28" height="28" fill="none" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="#FDE047"/><path d="M10 22l6-12 6 12" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round"/></svg>
            JobLoop
          </div>
          <p className="text-gray-500 text-sm max-w-xs">AI-powered job matching platform for modern employers.</p>
          <div className="flex gap-3 mt-3">
            {socials.map((s, i) => (
              <a key={i} href={s.href} className={`rounded-full p-2 ${s.color} text-white hover:scale-110 transition-transform w-9 h-9 flex items-center justify-center font-bold text-sm`} aria-label="Social link">
                {s.icon}
              </a>
            ))}
          </div>
        </div>
        <div className="flex gap-12">
          <div>
            <div className="font-semibold mb-2 text-gray-800">Company</div>
            <ul className="space-y-1">
              {companyLinks.map(link => (
                <li key={link.name}>
                  {link.to.startsWith('/') ? (
                    <Link to={link.to} className="text-gray-600 hover:text-primary transition-colors text-sm">{link.name}</Link>
                  ) : (
                    <a href={link.to} className="text-gray-600 hover:text-primary transition-colors text-sm">{link.name}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-semibold mb-2 text-gray-800">Resources</div>
            <ul className="space-y-1">
              {resourceLinks.map(link => (
                <li key={link.name}>
                  {link.to.startsWith('/') ? (
                    <Link to={link.to} className="text-gray-600 hover:text-primary transition-colors text-sm">{link.name}</Link>
                  ) : (
                    <a href={link.to} className="text-gray-600 hover:text-primary transition-colors text-sm">{link.name}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="text-center text-xs text-gray-400 mt-8">© {new Date().getFullYear()} JobLoop. All rights reserved.</div>
    </footer>
  );
}
